/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRole {
  Carrier = 'carrier',
  Consignee = 'consignee',
  Consignor = 'consignor',
  OrganizationAdministrator = 'organization_administrator',
  SiteAdmin = 'site_admin'
}
